import { generatePath } from "react-router-dom";

import { URLS } from "@/api/urls";
import { FilterOptions } from "@/types/FilterOptions";
import { Tag } from "@/types/Tag";

import fetcher_v2 from "../fetcher_v2";

export const deleteTag = (tag: string) => {
  return fetcher_v2(URLS.TAGS, {
    method: "DELETE",
    body: { tags: [tag] },
  });
};

export const getTags = () => {
  return fetcher_v2<Tag[]>(URLS.TAGS);
};

export const setTag = ({
  mentionUuids,
  tags,
}: {
  mentionUuids?: string[];
  tags?: string[];
}) => {
  return fetcher_v2(URLS.TAGS, {
    method: "POST",
    body: {
      tags,
      mentionUuids,
    },
  });
};

export const getTagFilterOptions = (tag: string) => {
  return fetcher_v2<FilterOptions>(
    generatePath(URLS.TAGS_FILTER_OPTIONS, { tag }),
    {
      method: "GET",
    }
  );
};
